import React from 'react';
import Flex from './Flex';
// import BurnIcon from 'img/burn-pink.svg';
// import BurnIcon from 'img/burn-sand.svg';
import EthSign from './EthSign';
import { ReactComponent as Logo } from 'img/burn.svg';
import { useTheme } from 'styled-components';
interface BurnSignProps {
  burnPrice: string;
}

const BurnSign: React.FC<BurnSignProps> = ({ burnPrice }) => {
  const { colors } = useTheme();

  return (
    <Flex color="copy" alignCenter>
      <EthSign value={burnPrice} alignSelf="flex-end" />
      <Flex ml="2">
        <Logo fill={colors.highlight} />
      </Flex>
    </Flex>
  );
};

export default BurnSign;
